module.exports = __webpack_public_path__ + "static/media/list-active.517da424.svg";